var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
export var StyledInputHidden = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));

var InputHidden = function InputHidden(_a) {
  var name = _a.name,
      props = __rest(_a, ["name"]);

  return React.createElement(StyledInputHidden, Object.assign({
    className: "input-hidden",
    type: "hidden",
    name: name
  }, props));
};

export default InputHidden;
var templateObject_1;